import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Fragment, useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { connect } from 'react-redux';
import { MediaContext } from '@spa/shared/contexts/media';
import OfferViewDesktop from './Desktop';
import OfferViewMobile from './Mobile';
import { OfferHeader, OfferFooter } from './styles';
import { useStreams } from '@spa/shared/hooks/streams';
import { addAuthentication } from '@spa/shared/clients/core';
import { trackViewOfferPage } from '@spa/offer/store/actions/tracking';
import { generateGalleryGrid as _generateGalleryGrid, getOfferViews } from '@spa/offer/store/actions/offer';
var OfferView = function OfferView(_ref) {
  var isCrawler = _ref.isCrawler,
    guestName = _ref.guestName,
    token = _ref.token,
    isLoggedIn = _ref.isLoggedIn,
    notificationEmail = _ref.notificationEmail,
    offerAggregate = _ref.offerAggregate,
    generateGalleryGrid = _ref.generateGalleryGrid,
    trackViewOfferPageAction = _ref.trackViewOfferPageAction,
    loadOfferViews = _ref.loadOfferViews,
    referrer = _ref.referrer,
    profile = _ref.profile,
    priceDetails = _ref.priceDetails;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useContext = useContext(MediaContext),
    is = _useContext.is;
  useStreams([offerAggregate], referrer, isCrawler);
  var Component = useMemo(function () {
    return is.mobile ? OfferViewMobile : OfferViewDesktop;
  }, [is.mobile]);
  useEffect(function () {
    generateGalleryGrid();
    loadOfferViews(language);
    if (token) {
      addAuthentication(token);
    }
    var _offerAggregate$accom = offerAggregate.accommodation_offer;
    _offerAggregate$accom = _offerAggregate$accom === void 0 ? {} : _offerAggregate$accom;
    var offerGenderRestriction = _offerAggregate$accom.restrictions.gender,
      _offerAggregate$prope = offerAggregate.property_aggregate.property.restrictions.gender,
      propertyGenderRestriction = _offerAggregate$prope === void 0 ? [] : _offerAggregate$prope;
    trackViewOfferPageAction(_objectSpread(_objectSpread({}, offerAggregate), {}, {
      language: language,
      profile: profile,
      priceDetails: priceDetails
    }), notificationEmail, referrer, offerGenderRestriction, propertyGenderRestriction);
  }, []);
  return __jsx(Fragment, null, __jsx(OfferHeader, {
    isLoggedInOutsideOfContext: isLoggedIn,
    guestName: guestName
  }), __jsx(Component, null), __jsx(OfferFooter, {
    t: t,
    language: language,
    withPaymentMethods: true
  }));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var _profile$basic_info, _profile$basic_info$f, _profile$contacts;
  var _ref2$profile = _ref2.profile,
    isLoggedIn = _ref2$profile.isLoggedIn,
    token = _ref2$profile.token,
    profile = _ref2$profile.profile,
    profileDefault = _ref2.profile,
    _ref2$offer = _ref2.offer,
    offerAggregate = _ref2$offer.offerAggregate,
    referrer = _ref2$offer.tracking.referrer,
    priceDetails = _ref2$offer.priceDetails,
    page = _ref2.page;
  var guestName = profile === null || profile === void 0 ? void 0 : (_profile$basic_info = profile.basic_info) === null || _profile$basic_info === void 0 ? void 0 : (_profile$basic_info$f = _profile$basic_info.full_name) === null || _profile$basic_info$f === void 0 ? void 0 : _profile$basic_info$f.first;
  var notificationEmail = profile === null || profile === void 0 ? void 0 : (_profile$contacts = profile.contacts) === null || _profile$contacts === void 0 ? void 0 : _profile$contacts.notification_email_address;
  return {
    isCrawler: page === null || page === void 0 ? void 0 : page.isCrawler,
    guestName: guestName,
    token: token,
    isLoggedIn: isLoggedIn,
    notificationEmail: notificationEmail,
    offerAggregate: offerAggregate,
    referrer: referrer,
    profile: profileDefault,
    priceDetails: priceDetails
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    generateGalleryGrid: function generateGalleryGrid() {
      return dispatch(_generateGalleryGrid());
    },
    loadOfferViews: function loadOfferViews(locale) {
      return dispatch(getOfferViews(locale));
    },
    trackViewOfferPageAction: function trackViewOfferPageAction(trackingData, notificationEmail, referrer, offerGenderRestriction, propertyGenderRestriction) {
      return dispatch(trackViewOfferPage({
        trackingData: trackingData,
        notificationEmail: notificationEmail,
        referrer: referrer,
        offerGenderRestriction: offerGenderRestriction,
        propertyGenderRestriction: propertyGenderRestriction
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OfferView);